<template>
    <div class="grid">
        <div class="col">
            <DataTable :value="history" :rows="history.length">
                <Column field="time" :header="$t('lang.main.history.column_time')" />
                <Column field="query" :header="$t('lang.main.history.column_query')">
                    <template #body="{ data }">
                        <a :href="data.link">{{ data.type }} {{ data.domain }}</a>
                    </template>
                </Column>
            </DataTable>
        </div>
    </div>
</template>

<script>
import DataTable from "primevue/datatable";
import Column from "primevue/column";

export default {
    name: "HistoryQueries",
    props: {
        history: {
            type: Array,
            required: true,
        }
    },
    components: {
        DataTable,
        Column,
    }
}
</script>
